import * as React from 'react';
import { toast } from '@grandvisionhq/common';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { cartPaymentMethods } from '../mappers/cart-payment-methods.js';
import { errorsMapping } from '../mappers/errors-mapping.js';
import { GET_CART_PAYMENT_METHODS } from '../operations/queries/get-cart-payment-methods.js';
import '../operations/queries/get-cart-express-payment-methods.js';
import '../operations/queries/get-payment-status-by-token.js';
import { useIsApplePayActive } from './use-is-apple-pay-active.js';

const useGetCartPaymentMethods = ()=>{
    const isApplePayActive = useIsApplePayActive();
    const [getCartPaymentMethods, { called , loading , data , error: error1  }] = useLazyQuery(GET_CART_PAYMENT_METHODS, {
        onError (error) {
            console.error(error);
            // General error for apollo error response
            toast.failed(errorsMapping.SOMETHING_WENT_WRONG);
        }
    });
    const getPaymentMethods = React.useCallback((cartId)=>{
        if (cartId) {
            getCartPaymentMethods({
                variables: {
                    cartId
                }
            });
        }
    }, [
        getCartPaymentMethods
    ]);
    const queryResults = React.useMemo(()=>({
            data: data ? cartPaymentMethods(data, isApplePayActive) : undefined,
            called,
            loading,
            error: error1
        })
    , [
        called,
        data,
        error1,
        loading,
        isApplePayActive
    ]);
    return [
        getPaymentMethods,
        queryResults
    ];
};

export { useGetCartPaymentMethods };
//# sourceMappingURL=use-get-cart-payment-methods.js.map
